if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const endDate = this.getAttribute('data-end');
      if (!endDate) {
        this.style.display = "none"; // Hide the element
        return;
      }
      
      this.updateCountdown(endDate);
      setInterval(() => {
        this.updateCountdown(endDate);
      }, 1000);
    }

    formatNumberWithZero(number) {
      return number.toString().padStart(2, '0');
    }

    updateCountdown(endDate) {
      var end = new Date(endDate).getTime();
      var now = new Date().getTime();
      var distance = end - now;
      if (distance < 0) {
        this.innerHTML = '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">Days</span></div>';
        this.innerHTML += '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">Hours</span></div>';
        this.innerHTML += '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">Minutes</span></div>';
        this.innerHTML += '<div class="countdown_block"><span class="timer_number">00</span><span class="timer_label">Seconds</span></div>';
        return;
      }
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      this.innerHTML = '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(days)+'</span><span class="timer_label">Days</span></div>';
      this.innerHTML += '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(hours)+'</span><span class="timer_label">Hours</span></div>';
      this.innerHTML += '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(minutes)+'</span><span class="timer_label">Minutes</span></div>';
      this.innerHTML += '<div class="countdown_block"><span class="timer_number">'+this.formatNumberWithZero(seconds)+'</span><span class="timer_label">Seconds</span></div>';
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}


//Success Popup
const themeSuccessModalElements = document.querySelectorAll('.success_modal');
themeSuccessModalElements.forEach(function(element) {
  var themeSuccessModal = new bootstrap.Modal(element, {
    keyboard: false
  });
  themeSuccessModal.show();
});


//Height Calculator
function calculateAndSetHeight() {
  const divElements = document.querySelectorAll('[height-calculate]'); 
  divElements.forEach(divElement => {
    const height = divElement.offsetHeight; 
    const parentElement = divElement.parentElement;
    parentElement.style.setProperty('--element-height', height + 'px'); 
  });
}

//Collection Grid Swatcher
function CollectionGridSwitcher(){
  const buttons = document.querySelectorAll('.short_head button');
  buttons.forEach(function(button) {
    button.addEventListener('click', function() {
      const grid = document.querySelector('.collection_product_grid');
      
      if (this.id === 'grid_view') {
        grid.classList.toggle('grid_2_column_enable');
        grid.classList.remove('gird_list_view_enable');
      } 
      if (this.id === 'grid_list') {
        grid.classList.toggle('gird_list_view_enable');
        grid.classList.remove('grid_2_column_enable');
      }
    });
  });
}


const header = document.querySelector('.section_header');
const scrollUp = 'sticky-up';
const scrollDown = 'sticky-down';
let lastScroll = 0;
window.addEventListener('scroll', () => {
  const currentScroll = window.pageYOffset;

  if (currentScroll <= 0) {
    header.classList.remove(scrollUp);
    return;
  }

  if (currentScroll > lastScroll && !header.classList.contains(scrollDown)) {
    // down
    header.classList.remove(scrollUp);
    header.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && header.classList.contains(scrollDown)) {
    // up
    header.classList.remove(scrollDown);
    header.classList.add(scrollUp);
  }

  lastScroll = currentScroll;
});



//Remove Quick Cart
const outerCart = document.querySelector('.outer_quick_cart');
outerCart?.addEventListener('click', () => {
  document.body.classList.remove('js-my-cart-open');
});


//Collection Filter Toggle
const filterToggle = document.querySelector('#filter_toggle');
function toggleFilter() {
  const templates = document.querySelectorAll('.main_collection_template, .search_page_template');
  templates.forEach(template => template.classList.toggle('collection_filter_enable'));
}
if (filterToggle) {
  filterToggle.addEventListener('click', toggleFilter);
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
}; 
  
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
    });
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    this.querySelector('.template-popup')?.loadContent();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');

    // removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');
    button?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-modal'))?.show(button);
    });

    const a = this.querySelector('a:not(.btn-wishlist)');
    a?.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector(this.getAttribute('data-modal'))?.show(a);
    });
  }

}
customElements.define('modal-opener', ModalOpener);  


class BeedaCarousel extends HTMLElement {
  connectedCallback() {
    const desktop_items = parseInt(this.dataset.desktop);
    const tablate_items = parseInt(this.dataset.tablate);
    const mobile_items = parseInt(this.dataset.mobile);
    const slide_autoplay = this.dataset.autoplay === "true";
    const slider_arrows = this.dataset.arrows === "true";
    const animation_speed = parseInt(this.dataset.animationSpeed);
    const item_speed = parseInt(this.dataset.itemSpeed);
    const slider_dots = this.dataset.dots === "true";
    const slider_infinite_loop = this.dataset.infiniteLoop === "true";
    const slider_scroll = parseInt(this.dataset.slidesToScroll);
    const slider_rows = parseInt(this.dataset.rows);
    const slider_vertical = this.dataset.vertical === "true";
    const slider_css = this.dataset.css;
    const slider_fade = this.dataset.fade === "true";
    const center_mode = this.dataset.centerMode === "true";
    const rtl = this.dataset.rtl === "true" ? true : false;
    const des_center_padding = this.dataset.desCenterPadding;
    const mob_center_padding = this.dataset.mobCenterPadding;
  
    $(this).slick({
      slidesToShow: desktop_items,
      arrows: slider_arrows,
      vertical: slider_vertical,
      rows: slider_rows,
      autoplay: slide_autoplay,
      speed: animation_speed,
      slidesToScroll: slider_scroll,
      dots: slider_dots,
      fade: slider_fade,
      adaptiveHeight: true,
      centerPadding: des_center_padding,
      centerMode: center_mode,
      autoplaySpeed: item_speed,       
      infinite: slider_infinite_loop,
      cssEase: slider_css,
      rtl: rtl,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: tablate_items
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: mobile_items,
            centerPadding: mob_center_padding
          }
        },
        {
          breakpoint: 410,
          settings: {
            slidesToShow: 1,
            centerPadding: 0
          }
        }
      ]
    });

    const sliderTitles = this.querySelectorAll('.slider_title');
    const subTitles = this.querySelectorAll('.slider_sub_title');
    const sliderContents = this.querySelectorAll('.slider_entry_content');
    const buttons = this.querySelectorAll('.slideshow_btn');
    sliderTitles.forEach((title) => {
      const titleAnimation = title.dataset.animation;
      const titleDelay = title.dataset.delay;
      title.style.setProperty('--title-animation', titleAnimation);
      title.style.setProperty('--title-delay', titleDelay);
    });

    subTitles.forEach((subTitle) => {
      const subtitleAnimation = subTitle.dataset.animation;
      const subtitleDelay = subTitle.dataset.delay;
      subTitle.style.setProperty('--subtitle-animation', subtitleAnimation);
      subTitle.style.setProperty('--subtitle-delay', subtitleDelay);
    });

    sliderContents.forEach((content) => {
      const ContentAnimation = content.dataset.animation;
      const ContentDelay = content.dataset.delay;
      content.style.setProperty('--content-animation', ContentAnimation);
      content.style.setProperty('--content-delay', ContentDelay);
    });

    buttons.forEach((button) => {
      const buttonAnimation = button.dataset.animation;
      const buttonDelay = button.dataset.delay;
      button.style.setProperty('--button-animation', buttonAnimation);
      button.style.setProperty('--button-delay', buttonDelay);
    });
  }
}
customElements.define('beeda-carousel', BeedaCarousel);



if (!customElements.get('menu-carousel')) {
  class MenuCarousel extends HTMLElement {
    connectedCallback() {
      const desktopItems = parseInt(this.dataset.desktop);
      const slideAutoplay = this.dataset.autoplay === "true";
      const sliderArrows = this.dataset.arrows === "true";
      const animationSpeed = parseInt(this.dataset.animationSpeed);
      const itemSpeed = parseInt(this.dataset.itemSpeed);
      const sliderDots = this.dataset.dots === "true";
      const sliderInfiniteLoop = this.dataset.infiniteLoop === "true";
      const sliderScroll = parseInt(this.dataset.slidesToScroll);

      const slickOptions = {
        slidesToShow: desktopItems,
        arrows: sliderArrows,
        autoplay: slideAutoplay,
        speed: animationSpeed,
        slidesToScroll: sliderScroll,
        dots: sliderDots,
        adaptiveHeight: true,
        autoplaySpeed: itemSpeed,
        infinite: sliderInfiniteLoop,
      };

      const parentElement = this.closest('.has-megamenu');
      if (parentElement) {
        const menuCarousel = parentElement.querySelector('.menu_carousel');
        if (menuCarousel) {
          const initializeSlider = () => {
            if (!menuCarousel.classList.contains('slick-initialized')) {
              $(menuCarousel).slick(slickOptions);
            }
          };

          parentElement.addEventListener('mouseenter', initializeSlider);
          parentElement.addEventListener('mouseover', initializeSlider);
        }
      }
    }
  }
  customElements.define('menu-carousel', MenuCarousel);
}


if (!customElements.get('soldout-timer')) {
  class SoldOutTimerElement extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.updateDataAttributes();
      setInterval(this.updateDataAttributes.bind(this), 60 * 60 * 1000);
    }

    generateRandomValues(items, hours) {
      var randomItemIndex = Math.floor(Math.random() * items.length);
      var randomHourIndex = Math.floor(Math.random() * hours.length);

      var randomItem = items[randomItemIndex];
      var randomHour = hours[randomHourIndex];

      return { item: randomItem, hour: randomHour };
    }

    updateDataAttributes() {
      var items = this.getAttribute('data-items').split(',').map(item => item.trim());
      var hours = this.getAttribute('data-hours').split(',').map(hour => hour.trim());

      var randomValues = this.generateRandomValues(items, hours);

      this.setAttribute('data-item', randomValues.item);
      this.setAttribute('data-hours', randomValues.hour);

      var soldOutNumber = this.querySelector('[data-sold-out-number]');
      soldOutNumber.textContent = randomValues.item;

      var soldOutHours = this.querySelector('[data-sold-out-hours]');
      soldOutHours.textContent = randomValues.hour;

      this.style.display = 'block';
    }
  }
  customElements.define('soldout-timer', SoldOutTimerElement);
}

if (!customElements.get('stock-sountdown')) {
  class Stockcountdown extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const progressBarAttr = this.getAttribute('data-progressbar');
      const numbers = progressBarAttr.split(',').map(Number);
      const getRandomNumber = () => {
        return numbers[Math.floor(Math.random() * numbers.length)];
      }

      const updateProgressBarAndCountdown = () => {
        const randomValue = getRandomNumber();
        const progressBarValue = (randomValue / 100) * 100;
        this.querySelector('#progress-bar').style.width = progressBarValue + '%';
        this.querySelector('#progessbar_soldout_item').textContent = randomValue;
      }

      const startCountdown = () => {
        const interval = setInterval(() => {
          updateProgressBarAndCountdown();
        }, 90000);
        updateProgressBarAndCountdown();
      }
      startCountdown();
    }
  }
  customElements.define('stock-sountdown', Stockcountdown); 
}

//Accordion
if (!customElements.get('kid-accordion')) {
  class KidAccordion extends HTMLElement {
    constructor() {
      super();
      const accordionTitles = this.querySelectorAll(".accordion_title");
      // code enable when first item will show by default
      /*if (accordionTitles.length > 0) {
        accordionTitles[0].classList.add("is-open");
        const accordionContent = accordionTitles[0].nextElementSibling;
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      }*/

      accordionTitles.forEach((accordion) => {
        accordion.onclick = function () {
          this.classList.toggle("is-open");
          let accordion_content = this.nextElementSibling;

          if (accordion_content.style.maxHeight) {
            accordion_content.style.maxHeight = null;
          } else {
            accordion_content.style.maxHeight = accordion_content.scrollHeight + "px";
          }
        };
      });
    }
  }
  customElements.define('kid-accordion', KidAccordion);
}

//Localication Form
if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
      }

      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        if (this.elements.button.getAttribute('aria-expanded') == 'false') return;
        this.hidePanel();
        event.stopPropagation();
        this.elements.button.focus();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }

      openSelector() {
        this.elements.button.focus();
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute(
          'aria-expanded',
          (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(event) {
        const isChild =
          this.elements.panel.contains(event.relatedTarget) || this.elements.button.contains(event.relatedTarget);
        if (!event.relatedTarget || !isChild) {
          this.hidePanel();
        }
      }
    }
  );
}

class VariantSelectElement extends HTMLElement {
  constructor() {
    super();
    this.initialized = false; // Track initialization status
  }

  connectedCallback() {
    if (!this.initialized) {
      const variantSelect = this.querySelector('.variant-select');
      const dropdownButton = this.querySelector('.dropdown-select-button');
      const cardDropdownArea = this.querySelector('.card_dropdown_area');

      if (!variantSelect || !dropdownButton || !cardDropdownArea) {
        return;
      }
      const variantListItems = variantSelect.querySelectorAll('li');

      const hideDropdown = () => {
        variantSelect.classList.remove('show');
        cardDropdownArea.classList.remove('active');
      };

      dropdownButton.addEventListener('click', () => {
        variantSelect.classList.toggle('show');
        cardDropdownArea.classList.toggle('active');
      });

      // Function to select the first variant by default and set the initial dropdown text
      const selectFirstVariant = () => {
        const firstVariant = variantListItems[0];
        if (firstVariant) {
          firstVariant.click(); 
          dropdownButton.textContent = firstVariant.textContent;
        }
      };

      variantListItems.forEach((li) => {
        li.addEventListener('click', () => {
          const selectedOption = li;
          const variantImage = selectedOption.dataset.variantImageUrl;
          const variantImageAlt = selectedOption.dataset.variantImageAlt;
          const variantId = selectedOption.dataset.variantId;
          const variantValue = selectedOption.textContent;

          const variantregular_price = selectedOption.dataset.variantRegularPrice;
          const variantcompare_price = selectedOption.dataset.variantComparePrice;

          const productCard = variantSelect.closest('.product_card, .outer_card');
          const productImage = productCard.querySelector('.card_feature_image img');
          const variantIdInput = productCard.querySelector('.variant-id-input');

          const newPriceElement = productCard.querySelector('.prodcut-price .new-price');
          const oldPriceElement = productCard.querySelector('.prodcut-price .old-price');

          variantListItems.forEach((item) => {
            item.classList.remove('active');
          });
          selectedOption.classList.add('active');

          if (variantImage) {
            productImage.setAttribute('src', variantImage);
            productImage.setAttribute('srcset', variantImage);
            productImage.setAttribute('alt', variantImageAlt);
          }

          if (variantregular_price) {
            newPriceElement.textContent = variantregular_price;
          }

          if (variantcompare_price) {
            oldPriceElement.textContent = variantcompare_price;
          }

          if (variantIdInput) {
            variantIdInput.value = variantId;
          }

          dropdownButton.textContent = variantValue;
          hideDropdown();
        });
      });

      document.addEventListener('click', (event) => {
        const targetElement = event.target;

        if (!cardDropdownArea.contains(targetElement) && targetElement !== dropdownButton) {
          hideDropdown();
        }
      });
      selectFirstVariant();
      this.initialized = true; 
    }
  }
}
customElements.define('variant-selects', VariantSelectElement);

if (!customElements.get('variant-selects')) {
  const variantSelects = document.createElement('variant-selects');
  document.body.appendChild(variantSelects);
}


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            initButtons();
            initButtonsCompare();
          }

          if (!this.querySelectorAll('.complementary-grid') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.recommended-items')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}
customElements.define('product-recommendations', ProductRecommendations);
       
function singleProductSlider() {
  const productImageSlides = document.querySelectorAll(".products_image_slide");

  productImageSlides.forEach(slide => {
    const sliderArrows = slide.getAttribute("data-arrows") === 'true';
    const sliderDots = slide.getAttribute("data-dots");
    const sliderVertical = slide.getAttribute("data-vertical") === 'true';
    const slideToShow = parseInt(slide.getAttribute("data-slidesToShow"));
    const carousel = document.querySelector('.beeda_product_gallery');
    const galleryNav = document.querySelector('.gallery_nav');

    const slickOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      arrows: false,
      asNavFor: galleryNav
    };

    const galleryNavOptions = {
      slidesToScroll: 1,
      asNavFor: carousel,
      vertical: sliderVertical,
      slidesToShow: slideToShow,
      dots: sliderDots,
      arrows: sliderArrows,
      focusOnSelect: true,
      rtl: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            vertical: false,
            slidesToShow: 4
          }
        }
      ]
    };

    $(carousel).slick(slickOptions);
    $(galleryNav).slick(galleryNavOptions);
  });
}
singleProductSlider();
CollectionGridSwitcher();
calculateAndSetHeight();


function getonloadscript(source, callback) {
  var script = document.createElement('script');
  var prior = document.getElementsByTagName('script')[0];
  script.async = 1;

  script.onload = script.onreadystatechange = function( _, isAbort ) {
      if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
          script.onload = script.onreadystatechange = null;
          script = undefined;

          if(!isAbort && callback) setTimeout(callback, 0);
      }
  };
  script.src = source;
  prior.parentNode.insertBefore(script, prior);
}

class QuickviewModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      if (event.target.nodeName === 'QUICKVIEW-MODAL') {
          this.hide();
      }
    });
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', () => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
  }
  
  async show(opener) {
    this.opener = opener;
    var href = this.opener.getAttribute('data-url');
    var quickview = href.includes('?') ? '&view=quickview' : '?view=quickview';
    this.setAttribute('open', '');

    const response = await fetch(href + quickview);
    const text = await response.text();
    const parsedHTML = new DOMParser().parseFromString(text, 'text/html');

    var pHtml = '';
    if (typeof ProductForm == 'undefined') {
      parsedHTML.querySelectorAll('noscript link').forEach((link) => {
        pHtml += link.outerHTML;
      });
      pHtml += parsedHTML.querySelector('script[defer="defer"]')?.outerHTML;
    }

    const productContainer = parsedHTML.querySelector('#product_quickview .product-container');
    if (productContainer) {
      pHtml += productContainer.innerHTML;
    }

    this.querySelector('.quickview-popup-content').innerHTML = pHtml;

    if (typeof ProductForm == 'undefined') {
      const scripts = this.querySelector('.quickview-popup-content').querySelectorAll('script');
          scripts.forEach(function(script){
            getonloadscript(script.getAttribute("src"));
          })
    }
    this.quickViewSlick();
  }

  quickViewSlick() {
    singleProductSlider();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.querySelector('quickview-modal .quickview-popup-content').innerHTML = '';    
    this.removeAttribute('open');
    if (!this.lastClickWasOnSwatch) {
      const url = new URL(window.location.href);
      const pathArray = url.pathname.split('/');
      
      if (pathArray.includes('products') && url.searchParams.get('variant')) {
        const productIndex = pathArray.indexOf('products');
        if (productIndex > -1) {
          pathArray.splice(productIndex, 3);
          url.pathname = pathArray.join('/');
        }
      }
      window.history.replaceState({}, document.title, url.toString());
    }
    this.lastClickWasOnSwatch = false;
  }
}
customElements.define('quickview-modal', QuickviewModal);

function setupScrollAnimation(className) {
  const animatedSections = document.querySelectorAll('.' + className);

  if (animatedSections.length === 0) {
    return;
  }

  let isScrollingDown = false;

  function checkScroll() {
    const offset = window.innerHeight - 50;

    animatedSections.forEach(animatedSection => {
      const rect = animatedSection.getBoundingClientRect();
      const isSectionVisible = rect.top < window.innerHeight && rect.bottom >= 0;

      if (isScrollingDown && (isSectionVisible && rect.top < offset)) {
        animatedSection.classList.add('animate');
      } else {
        animatedSection.classList.remove('animate');
      }
    });
  }

  function handleScrollDirection() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    isScrollingDown = scrollTop > (isScrollingDown ? lastScrollTop : lastScrollTop + 5);
    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
    checkScroll();
  }

  let lastScrollTop = 0;

  window.addEventListener('scroll', handleScrollDirection);
  window.addEventListener('load', checkScroll);
}

if (document.querySelectorAll('.animatedSection').length > 0) {
  setupScrollAnimation('animatedSection');
}
